import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "flex-center flex-col"
};
import { StaffMember } from "@/modules/staff/entity";
import StaffMemberComponent from "@/modules/staff/components/StaffMember.vue";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { app } from "@/di";
import { StaffMemberTransferator } from "@/modules/staff/services/StaffMemberTransferator";
import Gate from "@/modules/action-points/components/Gate.vue";
import { GateTypeEnum } from "@/modules/action-points/enums";
import { ConfigRepository } from "@/modules/base/services/ConfigRepository";
import ItemsPaginator from "@/modules/vue/components/ItemsPaginator.vue";
import GlobalResolver from "@/modules/base/services/GlobalResolver";
export default /*#__PURE__*/_defineComponent({
  __name: 'Sack',
  async setup(__props) {
    let __temp, __restore;
    const staffMembers = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      staffMembers.value = await StaffMember.createQueryBuilder('member').innerJoinAndSelect('member.team', 'team').where('team.user = true AND member.endsCareer = false').getMany();
    })), __temp = await __temp, __restore(), __temp);
    const form = ref({});
    const selectedMembers = computed(() => Object.keys(form.value).filter(k => form.value[k] === true).map(id => staffMembers.value.find(m => m.id === parseInt(id))));
    const cost = computed(() => app.get(ConfigRepository).get('staff.terminateContract.costNegotiationActionPoints')(selectedMembers.value));
    const count = computed(() => selectedMembers.value.length);
    const onContinue = async () => {
      app.get(GlobalResolver).resolvePromise();
    };
    const onSackAndContinue = async commit => {
      await selectedMembers.value.forEachAsync(async member => {
        await app.get(StaffMemberTransferator).sackForFree(member);
      });
      await commit();
      app.get(GlobalResolver).resolvePromise(count.value);
    };
    return (_ctx, _cache) => {
      const _component_NCheckbox = _resolveComponent("NCheckbox");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        "hide-tabbar": "",
        "hide-footer": ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sack_staff_members')), 1)]),
        subtitle: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sack_staff_members_for_free_will_cost_negotiations_action_points')), 1)]),
        footerButtons: _withCtx(() => [_unref(count) === 0 ? (_openBlock(), _createBlock(_component_NButton, {
          key: 0,
          type: "success",
          secondary: "",
          size: "large",
          onClick: onContinue,
          textContent: _toDisplayString(_ctx.$t('skip'))
        }, null, 8, ["textContent"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Gate, {
          type: _unref(GateTypeEnum).NEGOTIATION,
          value: _unref(cost),
          size: "large",
          "no-reset": "",
          onAction: onSackAndContinue
        }, {
          label: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sack_x_staff_members', {
            count: _unref(count)
          })), 1)]),
          _: 1
        }, 8, ["type", "value"])]))]),
        default: _withCtx(() => [_createVNode(ItemsPaginator, {
          ref: "paginator",
          "all-items": staffMembers.value
        }, {
          default: _withCtx(({
            items
          }) => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, staffMember => {
            return _openBlock(), _createBlock(StaffMemberComponent, {
              key: staffMember.id,
              "staff-member": staffMember,
              onSacked: _unref(refresh)
            }, {
              action: _withCtx(() => [_createVNode(_component_NCheckbox, {
                checked: form.value[staffMember.id],
                "onUpdate:checked": $event => form.value[staffMember.id] = $event
              }, null, 8, ["checked", "onUpdate:checked"])]),
              _: 2
            }, 1032, ["staff-member", "onSacked"]);
          }), 128))]),
          _: 1
        }, 8, ["all-items"])]),
        _: 1
      });
    };
  }
});